import React, { useEffect, useState } from "react";
import AppBreadcrumb from "../../Shared/AppBreadcrumb";
import FecthingSpinner from "../../Shared/FecthingSpinner";
import httpService from "../../../services/http.service";
import * as logger from "../../../services/logger.service";
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";
import {
  formatCash,
  getUserFullName,
  extractResponseValidationErrors,
} from "../../../utils/index";
// moment n'est plus utilisé pour ce tableau

const PaymentCashout = ({ history }) => {
  const [users, setUsers] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loadingPaymentMethods, setLoadingPaymentMethods] = useState(false);

  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");

  // Modal de cashout
  const [cashoutModal, setCashoutModal] = useState({
    open: false,
    user: null,
  });
  const [paymentMethodId, setPaymentMethodId] = useState("");
  const [amount, setAmount] = useState("");
  const [submittingCashout, setSubmittingCashout] = useState(false);
  const [cashoutError, setCashoutError] = useState(null);
  const [cashoutSuccess, setCashoutSuccess] = useState(null);

  const fetchData = async (currentPage = 1, currentSearch = "") => {
    setFetching(true);
    try {
      const response = await httpService.get(`/payments/top-users-usd`, {
        params: {
          page: currentPage,
          search: currentSearch || undefined,
        },
      });

      const payload = response?.data?.data || response?.data || {};
      logger.debug("Top users USD chargés", { page: currentPage, usersCount: payload.users?.data?.length });
      const usersWrapper = payload.users || {};
      const items = Array.isArray(usersWrapper)
        ? usersWrapper
        : usersWrapper.data || [];

      setUsers(items);
      // Métadonnées de pagination (structure type Laravel)
      const current_page = usersWrapper.current_page || currentPage;
      const last_page = usersWrapper.last_page || 1;
      const total = usersWrapper.total || items.length;

      setPage(current_page);
      setLastPage(last_page);
      setTotalItems(total);
    } catch (error) {
      logger.error("Erreur chargement top users USD", error);
    } finally {
      setFetching(false);
    }
  };

  const searchUsers = async (currentPage = 1, currentSearch = "") => {
    setFetching(true);
    try {
      const response = await httpService.get(`/payments/top-users-usd/search`, {
        params: {
          q: currentSearch || undefined,
          page: currentPage,
        },
      });

      const payload = response?.data?.data || response?.data || {};
      logger.debug("Recherche utilisateurs effectuée", { query: currentSearch, resultsCount: payload.users?.data?.length });
      const usersWrapper = payload.users || {};
      const items = Array.isArray(usersWrapper)
        ? usersWrapper
        : usersWrapper.data || [];

      setUsers(items);

      const current_page = usersWrapper.current_page || currentPage;
      const last_page = usersWrapper.last_page || 1;
      const total = usersWrapper.total || items.length;

      setPage(current_page);
      setLastPage(last_page);
      setTotalItems(total);
    } catch (error) {
      logger.error("Erreur recherche utilisateurs", error);
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    const term = search?.trim();
    if (term) {
      // Recherche serveur
      searchUsers(page, term);
    } else {
      // Liste globale sans filtre
      fetchData(page, "");
    }
  }, [page, search]);

  const navigateToUserProfile = (row) => {
    if (!row || !row.user) return;
    history.push(`/users/${row.user.user_username}`);
  };

  const onSubmitSearch = (e) => {
    e.preventDefault();
    setPage(1);
    setSearch(searchInput.trim());
  };

  const onResetSearch = () => {
    if (!searchInput?.trim()) return;
    setSearchInput("");
    setPage(1);
    setSearch("");
  };

  const onPrevPage = () => {
    if (page > 1) {
      setPage((p) => p - 1);
    }
  };

  const onNextPage = () => {
    if (page < lastPage) {
      setPage((p) => p + 1);
    }
  };

  const fetchPaymentMethods = async () => {
    try {
      setLoadingPaymentMethods(true);
      const response = await httpService.get("/payment-methods");

      if (response?.data?.success) {
        const methods = response.data.data?.map((item) => ({
          ...item,
          countries: Array.isArray(item?.countries)
            ? item.countries.filter((country) => country?.code)
            : [],
        }));

        setPaymentMethods(methods || []);
        logger.debug("Méthodes de paiement chargées", { methodsCount: methods?.length });
      } else {
        logger.error("API /payment-methods returned success: false");
      }
    } catch (error) {
      logger.error("Erreur chargement méthodes de paiement", error);
    } finally {
      setLoadingPaymentMethods(false);
    }
  };

  const openCashoutModal = (row) => {
    if (!row || !row.user) return;
    setCashoutModal({
      open: true,
      user: row.user,
    });
    setPaymentMethodId("");
    setAmount("");
    setCashoutError(null);
    setCashoutSuccess(null);
    if (!paymentMethods || paymentMethods.length === 0) {
      fetchPaymentMethods();
    }
  };

  const closeCashoutModal = () => {
    setCashoutModal({ open: false, user: null });
    setPaymentMethodId("");
    setAmount("");
    setCashoutError(null);
    setCashoutSuccess(null);
    setSubmittingCashout(false);
  };

  const onSubmitCashout = async (e) => {
    e.preventDefault();
    if (!cashoutModal.user) return;

    const userId = cashoutModal.user.user_id;
    if (!userId) {
      setCashoutError("Utilisateur invalide.");
      return;
    }

    if (!paymentMethodId) {
      setCashoutError("Veuillez sélectionner une méthode de paiement.");
      return;
    }

    const parsedAmount = Number(amount);
    if (!parsedAmount || parsedAmount <= 0) {
      setCashoutError("Veuillez saisir un montant valide.");
      return;
    }

    try {
      setSubmittingCashout(true);
      setCashoutError(null);

      const response = await httpService.post(`/payments/cashout`, {
        user_id: userId,
        payment_method_id: Number(paymentMethodId),
        amount: parsedAmount,
      });

      logger.success("Cashout créé", { userId, amount: parsedAmount });
      if (response?.data?.success) {
        setCashoutSuccess("Cashout créé avec succès.");
        // Actualiser la liste des utilisateurs monétisés
        const currentSearchTerm = search?.trim();
        if (currentSearchTerm) {
          await searchUsers(page, currentSearchTerm);
        } else {
          await fetchData(page, "");
        }
        // Réinitialiser le formulaire et fermer le modal après un cashout réussi
        closeCashoutModal();
      } else {
        setCashoutError(response?.data?.message || "Erreur lors du cashout.");
      }
    } catch (error) {
      logger.error("Erreur lors du cashout", error);

      const response = error?.response;
      const status = response?.status;
      const data = response?.data;

      // 1) Erreurs de validation Laravel (422)
      if (status === 422 && data?.errors) {
        const messages = extractResponseValidationErrors(data);
        setCashoutError(
          messages[0] || "Données invalides, veuillez vérifier le formulaire."
        );
        return;
      }

      // 2) Erreurs métier avec message explicite côté API (400, 404, etc.)
      if (data?.message) {
        setCashoutError(data.message);
        return;
      }

      // 3) Erreurs sans réponse (problème réseau, timeout, etc.)
      if (!response) {
        setCashoutError(
          "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez."
        );
        return;
      }

      // 4) Fallback générique
      setCashoutError(
        "Erreur lors du cashout. Veuillez vérifier les informations ou réessayer."
      );
    } finally {
      setSubmittingCashout(false);
    }
  };

  return (
    <div className="container-fluid">
      <AppBreadcrumb title="Monétisation - Cashout" />

      <div className="row clearfix">
        <div className="col-md-12">
          <div className="card">
            <div className="font-weight-normal mb-2 d-flex justify-content-between align-items-center flex-wrap">
              <h5 className="mb-0">Top des comptes monétisés</h5>

              {/* Formulaire de recherche */}
              <form
                className="form-inline bg-light px-2 py-2 rounded shadow-sm"
                onSubmit={onSubmitSearch}
                style={{
                  gap: "8px",
                  border: "1px solid #e5e7eb",
                  minWidth: 360,
                }}
              >
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Rechercher un utilisateur..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  style={{
                    minWidth: 300,
                    borderRadius: "999px",
                    boxShadow: "0 0 0 1px rgba(148,163,184,0.3)",
                    border: "1px solid transparent",
                  }}
                />
                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  disabled={fetching}
                >
                  Rechercher
                </button>

                <button
                  type="button"
                  className={`btn btn-sm ${
                    !searchInput?.trim()
                      ? "btn-outline-secondary"
                      : "btn-danger"
                  } ${!searchInput?.trim() ? "disabled" : ""} ${
                    fetching ? "disabled" : ""
                  }`}
                  onClick={onResetSearch}
                  disabled={fetching}
                >
                  Réinitialiser
                </button>
              </form>
            </div>

            {fetching ? (
              <div className="p-3">
                <FecthingSpinner />
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover table-custom spacing8">
                  <thead>
                    <tr>
                      <th>Photo</th>
                      <th>Utilisateur</th>
                      <th>Followers</th>
                      <th>Coins (USD)</th>
                      <th>Likes (USD)</th>
                      <th>Vues (USD)</th>
                      <th>Total (USD)</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users?.map((row, index) => {
                      const user = row.user || {};
                      const balances = row.balances || {};
                      const coins = balances.coins || {};
                      const likes = balances.likes || {};
                      const views = balances.views || {};

                      return (
                        <tr
                          key={index}
                          onClick={() => navigateToUserProfile(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <td className="w60">
                            <img
                              src={user.prof_picture || MyOpinionLogo}
                              alt={`@(${user.user_username})`}
                              className="w35 rounded"
                              style={{ objectFit: "cover" }}
                            />
                          </td>
                          <td>{getUserFullName(user, true)}</td>
                          <td
                            className={`text-center font-weight-bold ${
                              (row.all_followers_count || 0) > 1000
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            {formatCash(
                              row.all_followers_count || 0
                            )}
                          </td>
                          <td className="text-center">
                            <b>{formatCash(coins.usd || 0)} USD</b> (
                            {formatCash(coins.amount || 0)})
                          </td>
                          <td className="text-center">
                            <b>{formatCash(likes.usd || 0)} USD</b> (
                            {formatCash(likes.amount || 0)})
                          </td>
                          <td>
                            <b>{formatCash(views.usd || 0)} USD</b> (
                            {formatCash(views.amount || 0)})
                          </td>
                          <td className="text-success font-weight-bold">
                            {formatCash(balances.total_usd || 0)} USD
                          </td>
                          <td>
                            <button
                              type="button"
                              className={`btn btn-sm ${
                                (row.all_followers_count || 0) > 1000
                                  ? "btn-success"
                                  : "btn-secondary"
                              }  font-weight-bold`}
                              // disabled={
                              //   (row.all_followers_count || 0) < 1000
                              // }
                              onClick={(e) => {
                                e.stopPropagation();
                                openCashoutModal(row);
                              }}
                            >
                              Cashout
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                    {!users || users.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center">
                          Aucun utilisateur trouvé.
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            )}

            {/* Pagination */}
            <div
              className="d-flex justify-content-between align-items-center p-3 pt-2 border-top"
              style={{ backgroundColor: "#f9fafb" }}
            >
              <div className="text-muted">
                <small style={{ fontSize: 12 }}>
                  Page {page} / {lastPage} – {totalItems} utilisateurs
                </small>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-sm mr-2"
                  onClick={onPrevPage}
                  disabled={page <= 1 || fetching}
                  style={{
                    borderRadius: "999px",
                    border: "1px solid #d1d5db",
                    backgroundColor:
                      page <= 1 || fetching ? "#e5e7eb" : "#ffffff",
                    color: "#374151",
                  }}
                >
                  Précédent
                </button>
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={onNextPage}
                  disabled={page >= lastPage || fetching}
                  style={{
                    borderRadius: "999px",
                    border: "1px solid #d1d5db",
                    backgroundColor:
                      page >= lastPage || fetching ? "#e5e7eb" : "#ffffff",
                    color: "#374151",
                  }}
                >
                  Suivant
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Cashout */}
      <div
        className={`modal fade ${cashoutModal.open ? "d-block show" : ""}`}
        style={{ backgroundColor: cashoutModal.open ? "rgba(0,0,0,0.4)" : "" }}
        onClick={closeCashoutModal}
      >
        <div
          className="modal-dialog"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <form onSubmit={onSubmitCashout} className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Cashout utilisateur</h5>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={closeCashoutModal}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              {cashoutError && (
                <div className="alert alert-danger" role="alert">
                  {cashoutError}
                </div>
              )}
              {cashoutSuccess && (
                <div className="alert alert-success" role="alert">
                  {cashoutSuccess}
                </div>
              )}

              <div className="form-group">
                <label>Utilisateur</label>
                <input
                  type="text"
                  className="form-control"
                  readOnly
                  value={
                    cashoutModal.user
                      ? getUserFullName(cashoutModal.user, true)
                      : ""
                  }
                />
              </div>

              <div className="form-group">
                <label>Méthode de paiement</label>
                <select
                  className="form-control"
                  value={paymentMethodId}
                  onChange={(e) => setPaymentMethodId(e.target.value)}
                  required
                >
                  <option value="">
                    {loadingPaymentMethods
                      ? "Chargement des méthodes..."
                      : "Sélectionner une méthode"}
                  </option>
                  {paymentMethods.map((method) => (
                    <option key={method.method_id} value={method.method_id}>
                      {method.method_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Montant (USD)</label>
                <input
                  type="number"
                  className="form-control"
                  min="1"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-round btn-danger font-weight-bold"
                onClick={closeCashoutModal}
                disabled={submittingCashout}
              >
                Annuler
              </button>
              <button
                type="submit"
                className="btn btn-round btn-success font-weight-bold"
                disabled={submittingCashout}
              >
                {submittingCashout ? "Traitement..." : "Valider le cashout"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PaymentCashout;
